import React, { memo, useEffect, useState } from "react"
import styles from "../../assets/scss/authentication.module.scss"
import { Alert, message } from "antd"
import { useDispatch, useSelector } from "react-redux"
import OtpInput from "react-otp-input"
import Timer from "react-compound-timer"
import { CLEAR_AUTHENTICATION_DATA, LOGGED_IN_SUCCESS, SEND_OTP, UPDATE_MOBILE_REQUEST, USER_DETAILS, VERIFY_OTP } from "../../actions/types"
import { AppLocalStorage, AppStorageKeys } from "../../services/contracts"
import { getDeviceInfo, reloadPage } from "../../utilities"
import NeedHelpModal from "../NeedHelpModal"
import moment from "moment"
import { useHistory } from "react-router-dom"

const timer = 30000

function OTP(props) {
  const { changeNumber, changeNumberFor, number, email, closeAuth, setIsResendOtp, usingViaEmail } = props
  const [otp, setOtp] = useState("")
  const [endTimer, setEndTimer] = useState(false)
  const [isModalVisible, setIsModalVisible] = useState(false)
  const authentications = useSelector((state) => state.authentications)
  const { domainDetails } = useSelector((state) => state.listings)
  const { currentCountry } = useSelector((state) => state.utilities)
  const dispatch = useDispatch()

  const history = useHistory()

  useEffect(() => {
    getEndTimer()
  }, [])

  const onChange = (otp) => {
    setOtp(otp)
  }

  useEffect(() => {
    if (otp.length === 6) {
      verifyOtp()
    }
  }, [otp])

  const verifyOtp = () => {
    dispatch({
      type: VERIFY_OTP,
      payload:
        usingViaEmail || currentCountry !== "IN"
          ? {
              email: email,
              otp: otp,
              currentDevice: getDeviceInfo(),
              deviceToken: `Web_${number.nationalNumber}_${getFormattedTime()}`,
            }
          : {
              mobileNumber: number.nationalNumber,
              otp: otp,
              currentDevice: getDeviceInfo(),
              deviceToken: `Web_${number.nationalNumber}_${getFormattedTime()}`,
            },
    })
  }

  const getFormattedTime = () => {
    const today = new Date()
    if (today) {
      const y = today.getFullYear()
      const m = today.getMonth() + 1
      const d = today.getDate()
      const h = today.getHours()
      const mi = today.getMinutes()
      const s = today.getSeconds()
      return y + "-" + m + "-" + d + "-" + h + "-" + mi + "-" + s
    }
    return ""
  }

  const attemptStatus = () => {
    dispatch({
      type: LOGGED_IN_SUCCESS,
      data: {
        status: "",
      },
    })
  }

  const sendOtp = () => {
    setEndTimer(false)
    getEndTimer()
    attemptStatus()
    dispatch({
      type: SEND_OTP,
      payload: usingViaEmail
        ? {
            email: email,
            site: domainDetails && domainDetails.orgType === "certifier" ? "microsite" : "docpro",
            countrySortName: authentications.mobileDetails.country,
            organizationId: domainDetails.id,
          }
        : {
            mobileNumber: number.nationalNumber,
            site: domainDetails && domainDetails.orgType === "certifier" ? "microsite" : "docpro",
            countrySortName: authentications.mobileDetails.country,
            organizationId: domainDetails.id,
          },
    })
  }

  const getEndTimer = () => {
    setTimeout(() => {
      setEndTimer(true)
    }, timer)
  }

  if (authentications && authentications.status === "success" && authentications.loggedIn && authentications.loggedIn.status === "OK") {
    AppLocalStorage.save(AppStorageKeys.userAccessToken, authentications.loggedIn.users.accessToken)
    // AppLocalStorage.save(AppStorageKeys.entAuthRefereshToken, '');
    AppLocalStorage.save(AppStorageKeys.userName, `${authentications.loggedIn.users.firstName} ${authentications.loggedIn.users.lastName}`)
    AppLocalStorage.save(AppStorageKeys.userId, authentications.loggedIn.users.id)
    AppLocalStorage.save(AppStorageKeys.userEmail, authentications.loggedIn.users.email)
    // AppLocalStorage.save(AppStorageKeys.profilePic, authentications.loggedIn.users.profilePic ? authentications.loggedIn.users.profilePic : '');
    AppLocalStorage.save(AppStorageKeys.primaryRole, authentications.loggedIn.users.primaryRole)
    // AppLocalStorage.save(AppStorageKeys.userTitle, authentications.loggedIn.users.title);
    AppLocalStorage.save(AppStorageKeys.workingRole, authentications.loggedIn.users.workingRole)
    AppLocalStorage.save(AppStorageKeys.isMCIverified, authentications.loggedIn.users.isRegistrationVerified)
    // AppLocalStorage.save(AppStorageKeys.profileCompleted, authentications.loggedIn.users.profileCompleted);
    AppLocalStorage.save(AppStorageKeys.loginDate, moment().format())

    message.success("You have been logged in successfully!")
    dispatch({ type: USER_DETAILS, payload: authentications.loggedIn.users })
    reloadPage()
    closeAuth()
  }

  const requestChangeNumber = () => {
    if (changeNumberFor === "login") {
      console.log("go to login")
      changeNumber(false)
      dispatch({
        type: CLEAR_AUTHENTICATION_DATA,
      })
    } else if (changeNumberFor === "signup") {
      console.log("go to signup")
      changeNumber(true)
      attemptStatus()
      dispatch({
        type: UPDATE_MOBILE_REQUEST,
        payload: true,
      })
    } else {
      return
    }
  }

  return (
    <div className={styles.form_container_otp}>
      <p className={"text-center mt-8"}>
        {usingViaEmail || authentications.mobileDetails.country !== "IN" ? (
          <span>
            We have sent OTP to your registered <span className="font-black font-bold-500">email</span>.
          </span>
        ) : (
          <span>
            We have sent you an <span className="font-black font-bold-500">SMS</span> and <span className="font-black font-bold-500">email</span> with the OTP to <span className="font-black font-bold-500">{number.number}</span>.
          </span>
        )}{" "}
        {changeNumberFor === "signup" && usingViaEmail ? (
          ""
        ) : (
          <span onClick={requestChangeNumber} className="font-color-link cursor-pointer hovered-pink">
            Change {usingViaEmail ? "email" : "number"}?
          </span>
        )}
      </p>
      <div className={styles.otp_input_box}>
        <OtpInput value={otp} onChange={onChange} shouldAutoFocus numInputs={6} isInputNum={true} />
      </div>
      <p className={styles.centerContent}>
        Didn’t receive OTP?{" "}
        {!endTimer ? (
          <span>
            Resend OTP in{" "}
            <span className={styles.primaryText}>
              <Timer initialTime={timer} direction="backward">
                <Timer.Seconds /> seconds
              </Timer>
            </span>
          </span>
        ) : (
          <span
            onClick={() => {
              sendOtp()
              setIsResendOtp(true)
            }}
            className={styles.linkButton}
          >
            Resend OTP
          </span>
        )}
      </p>
      {authentications && authentications.loggedIn.status === "BAD_REQUEST" ? <Alert message={authentications.loggedIn.message} type="warning" showIcon className={styles.mt_20} /> : null}
      <button onClick={verifyOtp} block disabled={otp === "" || otp.length < 6 ? true : false} loading={authentications.status === "verifying" ? true : false} className={styles.authButton}>
        VERIFY &amp; PROCEED
      </button>
      <p className={styles.centerContent}>
        Trouble signing in?{" "}
        <span onClick={() => setIsModalVisible(true)} className={styles.linkButton}>
          Click here
        </span>
      </p>
      <NeedHelpModal visible={isModalVisible} setVisible={setIsModalVisible} />
    </div>
  )
}

export default memo(OTP)
